var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clickable-tile",on:{"!click":function($event){return _vm.navigate.apply(null, arguments)}}},[_c('div',{staticClass:"icon"},[_vm._t("icon",function(){return [_c('i',{staticClass:"fa fa-lg fa-gears"})]})],2),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }